// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAvailabilityStyles } from "@eisinc/Overrides/Components/ProductAvailability";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

productAvailabilityStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productAvailabilityStyles.tableContainer = {
    css: css`
        overflow: auto;
    `,
};

productAvailabilityStyles.containerWithAdditionalMessage = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

productAvailabilityStyles.additionalMessageContainer = {
    css: css`
        display: flex;
        flex-direction: column;

        > div {
            line-height: 18px;
        }
    `,
};

productAvailabilityStyles.messageGridItem = {};

productAvailabilityStyles.availabilityByWarehouseLinkGridItem = {};

productAvailabilityStyles.availabilityByWarehouseModal = {
    size: 1000,
    cssOverrides: {
        modalContainer: css`
            overflow: auto;
            white-space: nowrap;
        `,
    },
};

productAvailabilityStyles.availabilityByWarehouseTable = {
    css: css`
        width: 100%;
        overflow: auto;
    `,
};

productAvailabilityStyles.spinner = {
    color: "primary.main",
    css: css`
        margin: 0 auto;
    `,
};

productAvailabilityStyles.messageText =
    productAvailabilityStyles.errorText =
    productAvailabilityStyles.pickupMessage =
    productAvailabilityStyles.realTimeText =
        {
            size: fontConfig.xSmall.size,
            lineHeight: fontConfig.singleLinexSmall.lineHeight,
            color: "text",
        };

productAvailabilityStyles.iconStyles = {
    size: 14,
    css: css`
        margin-right: 4px;
        @media print {
            width: 12px;
            height: 12px;
            margin-right: 2px;
        }
    `,
};

productAvailabilityStyles.fabProductPageLink = {
    typographyProps: {
        ...fontConfig.singleLinexSmall,
    },
};
